const DEFAULT_LANGUAGE = 'en';

function getSimplifiedCountryCode(locale?: string): string {
	return locale ? locale.substring(0, 2) : DEFAULT_LANGUAGE;
}

export default getSimplifiedCountryCode;
